import CreateUser from '../../components/CreateUser/CreateUser';
import Header from '../../components/Header/Header';
import './createuserpage.css';

function CreateUserPage() {
  return (
    <>
      <Header />
      <div className="create-user__container">
        <CreateUser />
      </div>
    </>
  );
}

export default CreateUserPage;
